@import "../../../theme/global";
$button-border-radius:        var(--lar-button-border-radius, 0.6rem) !default;


:host {
  user-select: none;
  overflow: hidden;
  width: 100%;
  display: flex;
}
::slotted(lar-button) {
  border-radius: 0;
  margin: 0 3px;
}
::slotted(lar-button:last-child) {
  border-radius: 0 $button-border-radius $button-border-radius 0;
  margin-right: 0;
}
::slotted(lar-button:first-child) {
  border-radius: $button-border-radius 0 0 $button-border-radius;
  margin-left: 0;
}

::slotted(lar-button:only-child) {
  border-radius: $button-border-radius !important;
  margin: 0 3px;
}
